import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Alert, Box, Button, Typography } from '@mui/material';
import GoogleIcon from '@mui/icons-material/Google';
import { supabase } from '../supabase/client';
import logo from '../assets/logo.png';
export default function Login({ unauthorizedEmail }) {
    const [error, setError] = useState('');
    const [submitting, setSubmitting] = useState(false);
    const handleGoogleSignIn = async () => {
        setError('');
        setSubmitting(true);
        const { error: signInError } = await supabase.auth.signInWithOAuth({
            provider: 'google',
            options: { redirectTo: window.location.origin },
        });
        if (signInError) {
            setError(signInError.message);
            setSubmitting(false);
        }
        // On success the browser navigates away to Google, then back here.
    };
    return (_jsx(Box, { sx: {
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: 'background.default',
        }, children: _jsxs(Box, { sx: {
                width: 360,
                maxWidth: '90vw',
                p: 4,
                borderRadius: '12px',
                border: '1px solid rgba(15, 23, 42, 0.08)',
                bgcolor: 'background.paper',
                textAlign: 'center',
            }, children: [_jsx(Box, { sx: { display: 'flex', justifyContent: 'center', mb: 3 }, children: _jsx(Box, { component: "img", src: logo, alt: "Helder", sx: { width: 150 } }, void 0) }, void 0), _jsx(Typography, { sx: { fontWeight: 700, fontSize: 18, mb: 0.5 }, children: "Sign in" }, void 0), _jsx(Typography, { variant: "body2", color: "text.secondary", sx: { mb: 3 }, children: "Sign in with Google to access your client data." }, void 0), unauthorizedEmail && (_jsxs(Alert, { severity: "error", sx: { mb: 2, textAlign: 'left' }, children: ["This app is restricted. You signed in as ", unauthorizedEmail, ", which doesn't have access."] }, void 0)), error && (_jsx(Alert, { severity: "error", sx: { mb: 2, textAlign: 'left' }, children: error }, void 0)), _jsx(Button, { variant: "contained", disableElevation: true, fullWidth: true, disabled: submitting, onClick: handleGoogleSignIn, startIcon: _jsx(GoogleIcon, { sx: { fontSize: 18 } }, void 0), sx: {
                        bgcolor: '#fff',
                        color: 'text.primary',
                        border: '1px solid rgba(15, 23, 42, 0.15)',
                        '&:hover': { bgcolor: 'rgba(15, 23, 42, 0.03)' },
                    }, children: submitting ? 'Redirecting…' : 'Sign in with Google' }, void 0)] }, void 0) }, void 0));
}
